var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-sidebar-menu",
      class: _vm.sidebarClass,
      style: [{ "max-width": _vm.sidebarWidth }],
      on: { mouseleave: _vm.onMouseLeave }
    },
    [
      _vm._t("header"),
      _c(
        "div",
        {
          staticClass: "vsm--scroll-wrapper",
          style: _vm.isCollapsed && [
            _vm.rtl ? { "margin-left": "-17px" } : { "margin-right": "-17px" }
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "vsm--list",
              style: _vm.isCollapsed && { width: _vm.widthCollapsed }
            },
            _vm._l(_vm.menu, function(item, index) {
              return _c(
                "sidebar-menu-item",
                {
                  key: index,
                  attrs: {
                    item: item,
                    "is-collapsed": _vm.isCollapsed,
                    "active-show": _vm.activeShow,
                    "show-one-child": _vm.showOneChild,
                    "show-child": _vm.showChild,
                    rtl: _vm.rtl,
                    "mobile-item": _vm.mobileItem,
                    "disable-hover": _vm.disableHover
                  },
                  on: {
                    "set-mobile-item": _vm.setMobileItem,
                    "unset-mobile-item": _vm.unsetMobileItem
                  }
                },
                [_vm._t("dropdown-icon", null, { slot: "dropdown-icon" })],
                2
              )
            }),
            1
          ),
          _vm.isCollapsed
            ? _c(
                "div",
                {
                  staticClass: "vsm--mobile-item",
                  style: _vm.mobileItemStyle.item
                },
                [
                  _vm.mobileItem
                    ? _c(
                        "sidebar-menu-item",
                        {
                          attrs: {
                            item: _vm.mobileItem,
                            "is-mobile-item": true,
                            "mobile-item-style": _vm.mobileItemStyle,
                            "is-collapsed": _vm.isCollapsed,
                            "show-child": _vm.showChild,
                            rtl: _vm.rtl
                          }
                        },
                        [
                          _vm._t("dropdown-icon", null, {
                            slot: "dropdown-icon"
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("transition", { attrs: { name: "slide-animation" } }, [
                    _vm.mobileItem
                      ? _c("div", {
                          staticClass: "vsm--mobile-bg",
                          style: _vm.mobileItemStyle.background
                        })
                      : _vm._e()
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._t("footer"),
      !_vm.hideToggle
        ? _c(
            "button",
            {
              staticClass: "vsm--toggle-btn",
              class: { "vsm--toggle-btn_slot": _vm.$slots["toggle-icon"] },
              on: { click: _vm.onToggleClick }
            },
            [_vm._t("toggle-icon")],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }